import type { DeliveryMethod, Maybe } from '../codegen/types';
import { ShippingType } from '../types/delivery';

export const isHomeShippingType = (shippingType?: Maybe<string>) =>
  shippingType ? [ShippingType.HOME_DEFAULT, ShippingType.HOME].includes(shippingType as ShippingType) : false;

export const isHomeDeliveryMethod = (deliveryMethod?: Maybe<DeliveryMethod>) =>
  isHomeShippingType(deliveryMethod?.shippingType);
